import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useApi } from '../../services/ApiServices.tsx'; // Servicio para hacer las solicitudes a la API
import { Tip } from '../../interfaces/TipDetalle.interface.ts';
import Header from '../../components/Header.tsx';
import Footer from '../../components/Footer.tsx';
import Loader from '../../components/Loader.jsx';
import Grid2 from '@mui/material/Grid2/Grid2';
import './TipDetalle.css';
import { Grid, Typography } from '@mui/material';
import BrandCarousel from '../../components/BrandCarousel/BrandCarousel.tsx';
import { useAuth } from '../../components/Auth/AuthContext.tsx';
import LoginModal from '../../components/LoginModal/LoginModal.tsx';
import TipComponent from './TipComponent.tsx';

const chilinTipImage = require('../../assets/img/chilin-tips.png');

function TipDetalle() {
  const { ApiRequest } = useApi();
  const { user } = useAuth();

  const navigate = useNavigate(); // Obtiene la función de navegación
  const { id } = useParams(); // Obtener el ID de la receta desde la URL
  const [tip, setTip] = useState<Tip | null>(null);
  const [principalTips, setPrincipalTips] = useState<Tip[] | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isFavorite, setIsFavorite] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchTipDetail = async () => {
      try {
        const data = await ApiRequest(`api/Tips/${id}`);
        setTip(data);
        await getFavorites();
      } catch (error) {
        console.error('Error fetching tip details:', error);
      } finally {
        setIsLoading(false);
      }
    };

    const fetchPrincipalTips = async () => {
      try {
        const data = await ApiRequest(`api/Tips/ObtenerTipsPrincipales`);
        setPrincipalTips(data);
      } catch (error) {
        console.error('Error fetching principal tips:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTipDetail();
    fetchPrincipalTips();
  }, [ApiRequest, id]);

  const handleOpenPDF = async () => {
    try {
      //const baseURL = process.env.REACT_APP_API_URL;
      const baseURL = window.REACT_APP_API_URL || "https://hoytoca2025-recipe-service.prd.cloudherdez.com";
      //const apikey = process.env.REACT_APP_API_KEY;
      const apikey = window.API_KEY || "HoyToca-Secret-2025~Di56m1-6BZWu6e+h>C";

      fetch(`${baseURL}/api/Tips/DescargarTipPdf?tipId=${id}`, {
        method: 'GET',
        headers: {
          'Origin': window.location.origin,
          'x-api-key': apikey
        }
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Error al descargar el PDF');
          }
          return response.blob();
        })
        .then(blob => {
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl, "_blank"); // Abre el PDF en nueva pestaña
        })
        .catch(error => {
          console.error('Error al descargar el PDF:', error);
        });



    } catch (error) {
      console.error("Error al abrir el PDF:", error);
    }
  };

  const handleShareURL = async () => {
    try {
      const currentUrl = window.location.href;
      if (navigator.share) {
        await navigator.share({
          title: 'Compartir Receta',
          text: 'Aquí tienes una receta para revisar:',
          url: currentUrl
        });
      } else {
        await navigator.clipboard.writeText(currentUrl);
        alert('Enlace copiado al portapapeles');
      }
    } catch (error) {
      console.error('Error al compartir la receta:', error);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const getFavorites = async () => {
    try {

      setIsFavorite(false);
      const url = `api/Tips/ObtenerTipsFavoritos?email=${user?.email ?? ""}`;
      const data = await ApiRequest(url, 'GET');

      // Verificar si el ID actual está en la lista de favoritos
      const isFavorite = data.some(favorite => favorite.id === id);

      if (isFavorite) {
        setIsFavorite(true);
        console.log("El elemento es un favorito");
        // Aquí puedes realizar alguna acción adicional si es favorito
      } else {
        setIsFavorite(false);
        console.log("El elemento no es un favorito");
      }

      return isFavorite;
    } catch (error) {
      console.error('Error fetching recetas:', error);
      return false; // En caso de error, asumimos que no es favorito
    }
  };
  const handleToggleFavorite = async () => {
    try {
      if (user == null) {
        handleLoginClick();
      } else {
        const body = JSON.stringify({ Email: user?.email ?? "", TipId: id });
        const url = !isFavorite ? 'api/Tips/AgregarTipFavorito' : 'api/Tips/EliminarTipFavorito';
        await ApiRequest(url, !isFavorite ? 'POST' : 'DELETE', body);

        getFavorites();
      }
    } catch (error) {
      console.error('Error fetching tip:', error);
      return [];
    }
  }

  const handleLoginClick = () => {
    setLoginOpen(true);
  };
  const handleCloseLogin = () => {
    setLoginOpen(false);
  };

  return (
    <Grid2>
      <Header />
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {tip && (
            <Grid2 container spacing={1} className='container-tip-detalle'>
              <Grid2 size={12} className='container-tip-header'>
                <Grid2 size={12} className={'imagen-tip-detalle'}>
                  <img
                    src={tip.imagen}
                    alt={tip.titulo}
                    className="imagen-tip-principal"
                  />
                </Grid2>

                {/* Botones alineados a la derecha */}
                <Grid2 size={12} className="right-buttons-container">
                  <button onClick={handleToggleFavorite} className="action-button-tip-noborder">
                    <span className="material-icons">{isFavorite ? "favorite" : "favorite_border"}</span>
                  </button>
                  <button onClick={handleOpenPDF} className="action-button-tip">
                    <span className="material-icons">system_update_alt</span>
                  </button>
                  <button onClick={handleShareURL} className="action-button-tip">
                    <span className="material-icons">share</span>
                  </button>
                  <button onClick={handlePrint} className="action-button-tip">
                    <span className="material-icons">print</span>
                  </button>
                </Grid2>

                <Grid2 size={12}><Typography className='titulo-tip-detalle'>{tip.titulo}</Typography></Grid2>
                <Grid2 size={12}><Typography className='titulo-tip-subdetalle'>{tip.descripcion}</Typography></Grid2>

                {/* Imagen redondeada del autor */}
                {chilinTipImage && (
                  <>
                    <Grid xs={12} className="autor-imagen-container">
                      <img src={chilinTipImage} alt="Autor" className="autor-imagen" />
                    </Grid>
                    <Grid xs={12} className="autor-imagen-container">
                      <p className="autor-nombre">{tip.autor}</p>
                    </Grid>
                  </>
                )}
              </Grid2>


              {/* Cuerpo del tip y lista de tips recientes */}
              <Grid2 container className="contenido-container">
                {/* Descripción completa */}
                <Grid2 size={{ xs: 12, md: 12, lg: 7 }} className="descripcion-completa">
                  <Typography className='descripcion-completa-texto'>{tip.cuerpo}</Typography>
                </Grid2>
                <Grid2 size={1} className="tips-recientes" />

                {/* Lo más visto */}
                <Grid2 size={{ xs: 12, md: 12, lg: 4 }} className="tips-recientes">
                  <Typography className='tips-recientes-header'>Lo más visto</Typography>
                  {principalTips && principalTips.map((reciente, index) => (
                    <TipComponent tip={reciente} />
                  ))}
                </Grid2>
              </Grid2>
            </Grid2>
          )}
        </>
      )}
      <Grid2>
        <BrandCarousel showTitle={false} />
      </Grid2>
      <LoginModal open={loginOpen} onClose={handleCloseLogin} />
      <Footer />
    </Grid2>
  );
}

export default TipDetalle;
